var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 2.53988 2.53988",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ff1f1f",
    r: 2.17,
    transform: "matrix(.414 -.414 .414 .414 1.27 1.27)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.16935 1.61.44065-.44065.34759-.3476c.06586-.06586.06586-.1736 0-.23946-.06586-.06586-.1736-.06586-.23946 0l-.3476.34759-.44065.44065-.34759.3476c-.06586.06586-.06586.1736 0 .23946.06586.06586.1736.06586.23946 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.61 1.37053-.44065-.44065-.3476-.34759c-.06586-.06586-.1736-.06586-.23946 0-.06586.06586-.06586.1736 0 .23946l.34759.3476.44065.44065.3476.34759c.06586.06586.1736.06586.23946 0 .06586-.06586.06586-.1736 0-.23946z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b0e8b210d8574b2b29681c7a2b67cba4.svg";
export { ForwardRef as ReactComponent };